import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async () => {
    try {
      const response = await api.get("/api/auth/me");
      setUser(response.data);
    } catch (error) {
      console.error("Fetch user error:", error);
      localStorage.removeItem("token");
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post("/api/auth/login", { email, password });
      const { token, ...userData } = response.data;

      localStorage.setItem("token", token);
      setUser(userData);

      return { success: true };
    } catch (error) {
      console.error("Login error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "लॉगिन में त्रुटि हुई",
      };
    }
  };

  const signup = async (name, email, password) => {
    try {
      const response = await api.post("/api/auth/signup", {
        name,
        email,
        password,
      });
      const { token, ...userData } = response.data;

      localStorage.setItem("token", token);
      setUser(userData);

      return { success: true };
    } catch (error) {
      console.error("Signup error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "पंजीकरण में त्रुटि हुई",
      };
    }
  };

  const firebaseLogin = async (idToken) => {
    try {
      const response = await api.post("/api/auth/firebase-login", { idToken });
      const { token, ...userData } = response.data;

      localStorage.setItem("token", token);
      setUser(userData);

      return { success: true };
    } catch (error) {
      console.error("Firebase login error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "OTP लॉगिन में त्रुटि हुई",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  const updateUser = (updatedUserData) => {
    setUser((prevUser) => ({ ...prevUser, ...updatedUserData }));
  };

  const value = {
    user,
    login,
    signup,
    firebaseLogin,
    logout,
    updateUser,
    loading,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
